import { tagIf, tagElse } from "./conditional";
import { partial } from "./partial";
import { table } from "./table";

export default {
	if: tagIf,
	else: tagElse,
	partial,
	table,
};
